
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
 apiKey: "AIzaSyBKtEZAubZvkeJIb4oIuAdzLAtWbD7DVJI",
  authDomain: "gcollection-788ef.firebaseapp.com",
  projectId: "gcollection-788ef",
  storageBucket: "gcollection-788ef.firebasestorage.app",
  messagingSenderId: "991674403971",
  appId: "1:991674403971:web:57c9ebef757dea84319fb6",
  measurementId: "G-EE0HPLY8RP"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const firestore = getFirestore(app);
